<template>
    <el-dialog title="Assign Device" :visible.sync="locValue.show" >
        <el-form :model="locValue" ref="dataForm"  v-loading="loading" :rules="pairRules">
                <el-form-item :required="true" label="First Name" :label-width="labelWidth" prop="firstName">
                    <el-input size="small" v-model="locValue.firstName"></el-input>
                </el-form-item>
                <el-form-item label="Last Name" :label-width="labelWidth" prop="lastName">
                    <el-input size="small" v-model="locValue.lastName"></el-input>
                </el-form-item>
                <el-form-item :required="true" v-if="enterEmail" label="Email" :label-width="labelWidth" prop="email">
                    <el-input size="small" v-model="locValue.email"></el-input>
                </el-form-item>
                <el-form-item :required="true" label="Email for reset password" :label-width="labelWidth" prop="resetEmail">
                    <el-input size="small" v-model="locValue.resetEmail"></el-input>
                </el-form-item>
                <el-form-item :required="true" label="GSR Country" prop="country" :label-width="labelWidth">
                    <el-select
                            size="small"
                            style="width: 100%"
                            value-key="id"
                            v-model="locValue.country"
                            filterable
                            remote
                            placeholder="Select GSR Country"
                            :remote-method="searchSRCountry"
                            :loading="searchingSRCountry">
                        <el-option
                                v-for="item in srCountries"
                                :key="item.id"
                                :label="item.name"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :required="true" label="User Country" :label-width="labelWidth" prop="userCountry">
                    <el-select
                            size="small"
                            style="width: 100%"
                            value-key="country"
                            v-model="locValue.userCountry"
                            filterable
                            placeholder="Select User Country">
                        <el-option
                                v-for="item in countryData"
                                :key="item.country"
                                :label="item.country"
                                :value="item">
                            <span style="float: left">{{ item.country }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.abbreviation }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :required="true" label="City" :label-width="labelWidth" prop="city">
                    <el-select
                            size="small"
                            style="width: 100%"
                            value-key="description"
                            v-model="locValue.city"
                            :loading="cityLoading"
                            filterable
                            remote
                            :remote-method="searchCity"
                            placeholder="Select City"
                            :disabled="!locValue.userCountry">
                        <el-option
                                v-for="item in cities"
                                :key="item.id"
                                :label="item.description"
                                :value="item.description">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :required="true" label="Mobile Number" :label-width="labelWidth" prop="mobileNo">
                    <el-input size="small" v-model="locValue.mobileNo"></el-input>
                </el-form-item>
                <el-form-item label="Contract/Order Number" :label-width="labelWidth" prop="contractNumber">
                    <el-input size="small" v-model="locValue.contractNumber"></el-input>
                </el-form-item>
                <el-form-item label="Comment" :label-width="labelWidth" prop="comment">
                    <el-input size="small" type="textarea" v-model="locValue.comment"></el-input>
                </el-form-item>
            </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="locValue.show = false">Cancel</el-button>
            <el-button size="small" type="primary" @click="submit()">Submit</el-button>
        </span>
    </el-dialog>
</template>

<script>
import api from '@/services/api/WRCService'
import countryData from "country-json/src/country-by-abbreviation.json";

export default {
    name: 'PairDevice',
    props: {
        value: Object,
        enterEmail: {
            default: true,
            type: Boolean
        }
    },
    data: function() {
        var validateContractNumber = (rule, value, callback) => {
            if (!value || value == '') {
                //callback(new Error('Please enter Contract Number'));
                callback();
            } else {
                let isnum = /^\d+$/.test(value);

                if (!isnum) {
                    callback(new Error('Contract Number can only contains number 0-9'));
                } else if (value.length < 6 || value.length > 8) {
                    callback(new Error('Contract Number length must be in between 6-8 characters'));
                }

                callback();
            }
        };

        var validateCountry = (rule, value, callback) => {
            if (!value || value == '' || !value.id) {
                callback(new Error('Please choose GSR Country'));
            } else {
                callback();
            }
        };

        return {
            pairRules: {
                contractNumber: [
                    { validator: validateContractNumber, trigger: 'change' }
                ],
                country: [
                    { validator: validateCountry, trigger: 'change' }
                ]
            },
            loading: false,
            searchingSRCountry: false,
            cityLoading: false,
            countryData: [],
            locValue: {
                country: {}
            },
            srCountries: [],
            cities: [],
            labelWidth: '180px'
        }
    },
    methods: {
        updateInput() {
            this.$emit('input', this.locValue)
        },
        searchCity(query) {
            this.cityLoading = true

            api.cityAutoComplete({
                query: query,
                countryCode: this.locValue.userCountry.abbreviation
            }).then(({ data }) => {

                this.cities = data.predictions;
            }).catch(() => {}).then(() => {
                this.cityLoading = false;
            });
        },
        searchSRCountry(query) {
            this.searchingSRCountry = true;

            api.getSRCountries(query, {
                page: 0,
                size: 100
            }).then(({ data }) => {

                this.srCountries.splice(0, this.srCountries.length);
                this.srCountries.push(...data.data.items);
                //this.pagination.total = data.total;
                //this.pagination.currentPage = data.currentPage;
            }).catch(() => {}).then(() => {
                this.searchingSRCountry = false;
            });
        },
        submit() {
            this.$emit('input', this.locValue)
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    this.$emit('submit-form')
                }
            })
        }
    },
    mounted() {
        this.searchSRCountry('')

        this.locValue = this.value
        this.countryData = countryData;
    },
    watch: {
        value: function(val) {
            this.locValue = val

            setTimeout(() => {
                if (!_.isUndefined(this.$refs['dataForm'])) {
                    this.$refs['dataForm'].clearValidate();
                }
            }, 1);
        }
    }
}
</script>
